"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lazy_1 = __importDefault(require("react-player/lazy"));
var axios_1 = __importDefault(require("axios"));
var react_gtm_module_1 = __importDefault(require("react-gtm-module"));
var styled_components_1 = __importDefault(require("styled-components"));
var once_1 = __importDefault(require("lodash/once"));
var react_2 = require("react");
var react_lazyload_1 = __importDefault(require("react-lazyload"));
var PlayerWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  padding-top: 56.25%;\n  box-shadow: ", ";\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"], ["\n  position: relative;\n  padding-top: 56.25%;\n  box-shadow: ", ";\n  .react-player {\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n"])), function (_a) {
    var boxShadow = _a.boxShadow;
    return boxShadow;
});
var OverlayContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: url(", ");\n  background-size: cover;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  @keyframes pulse-border {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(1.75);\n      opacity: 0;\n    }\n  }\n\n  @-webkit-keyframes pulse-border {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(1.75);\n      opacity: 0;\n    }\n  }\n\n  .player-icon-container {\n    position: relative;\n    background-color: rgba(233, 244, 253, 0.86);\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    @media (max-width: ", ") {\n      width: ", ";\n      height: ", ";\n    }\n  }\n\n  .play-icon-pulsing {\n    content: '';\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    left: 0;\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.76);\n    border-radius: 50%;\n    animation: pulse-border 1500ms ease-out infinite;\n  }\n\n  .play-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    border-style: solid;\n    border-width: ", ";\n    border-color: ", ";\n    margin-left: 5px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"], ["\n  cursor: pointer;\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: url(", ");\n  background-size: cover;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  @keyframes pulse-border {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(1.75);\n      opacity: 0;\n    }\n  }\n\n  @-webkit-keyframes pulse-border {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    100% {\n      transform: scale(1.75);\n      opacity: 0;\n    }\n  }\n\n  .player-icon-container {\n    position: relative;\n    background-color: rgba(233, 244, 253, 0.86);\n    border-radius: 50%;\n    width: ", ";\n    height: ", ";\n    @media (max-width: ", ") {\n      width: ", ";\n      height: ", ";\n    }\n  }\n\n  .play-icon-pulsing {\n    content: '';\n    position: absolute;\n    z-index: 0;\n    top: 0;\n    left: 0;\n    display: block;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(255, 255, 255, 0.76);\n    border-radius: 50%;\n    animation: pulse-border 1500ms ease-out infinite;\n  }\n\n  .play-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    border-style: solid;\n    border-width: ",
    ";\n    border-color: ",
    ";\n    margin-left: 5px;\n    &:hover {\n      cursor: pointer;\n    }\n  }\n"])), function (_a) {
    var poster = _a.poster;
    return poster;
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return (playIconSize + 40) * 1.7 + "px";
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return (playIconSize + 40) * 1.7 + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return (playIconSize + 25) * 1.7 + "px";
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return (playIconSize + 25) * 1.7 + "px";
}, function (_a) {
    var playIconSize = _a.playIconSize;
    return playIconSize + "px 0 " + playIconSize + "px " + playIconSize * 1.7 + "px !important";
}, function (_a) {
    var playIconColor = _a.playIconColor;
    return "transparent transparent transparent " + playIconColor + " !important";
});
var sendEvent = function (eventName) {
    react_gtm_module_1.default.dataLayer({
        dataLayer: { event: eventName }
    });
};
var sendEvent10Percent = function () {
    sendEvent('VIDEO_Played10');
};
var sendEvent10PercentOnce = once_1.default(sendEvent10Percent);
var sendEvent20Percent = function () {
    sendEvent('VIDEO_Played20');
};
var sendEvent20PercentOnce = once_1.default(sendEvent20Percent);
var sendEvent30Percent = function () {
    sendEvent('VIDEO_Played30');
};
var sendEvent30PercentOnce = once_1.default(sendEvent30Percent);
var sendEvent40Percent = function () {
    sendEvent('VIDEO_Played40');
};
var sendEvent40PercentOnce = once_1.default(sendEvent40Percent);
var sendEvent50Percent = function () {
    sendEvent('VIDEO_Played50');
};
var sendEvent50PercentOnce = once_1.default(sendEvent50Percent);
var sendEvent60Percent = function () {
    sendEvent('VIDEO_Played60');
};
var sendEvent60PercentOnce = once_1.default(sendEvent60Percent);
var sendEvent70Percent = function () {
    sendEvent('VIDEO_Played70');
};
var sendEvent70PercentOnce = once_1.default(sendEvent70Percent);
var sendEvent80Percent = function () {
    sendEvent('VIDEO_Played80');
};
var sendEvent80PercentOnce = once_1.default(sendEvent80Percent);
var sendEvent90Percent = function () {
    sendEvent('VIDEO_Played90');
};
var sendEvent90PercentOnce = once_1.default(sendEvent90Percent);
var onProgress = function (state) {
    if (state.played > 0.1) {
        sendEvent10PercentOnce();
    }
    if (state.played > 0.2) {
        sendEvent20PercentOnce();
    }
    if (state.played > 0.3) {
        sendEvent30PercentOnce();
    }
    if (state.played > 0.4) {
        sendEvent40PercentOnce();
    }
    if (state.played > 0.5) {
        sendEvent50PercentOnce();
    }
    if (state.played > 0.6) {
        sendEvent60PercentOnce();
    }
    if (state.played > 0.7) {
        sendEvent70PercentOnce();
    }
    if (state.played > 0.8) {
        sendEvent80PercentOnce();
    }
    if (state.played > 0.9) {
        sendEvent90PercentOnce();
    }
};
var ConditionalLazyLoad = function (_a) {
    var disableLazyLoading = _a.disableLazyLoading, lazyConfig = _a.lazyConfig, _b = _a.children, children = _b === void 0 ? null : _b;
    return disableLazyLoading ? (children) : (react_1.default.createElement(react_lazyload_1.default, __assign({}, lazyConfig), children));
};
var VideoPlayer = function (_a) {
    var url = _a.url, _b = _a.controls, controls = _b === void 0 ? true : _b, poster = _a.poster, _c = _a.loop, loop = _c === void 0 ? false : _c, _d = _a.autoplay, autoplay = _d === void 0 ? false : _d, _e = _a.muted, muted = _e === void 0 ? false : _e, _f = _a.volume, volume = _f === void 0 ? 0.8 : _f, _g = _a.playsinline, playsinline = _g === void 0 ? true : _g, _h = _a.color, color = _h === void 0 ? 'ffc000' : _h, _j = _a.title, title = _j === void 0 ? false : _j, _k = _a.boxShadow, boxShadow = _k === void 0 ? '10px 10px 30px 0px rgba(0, 0, 0, 0.25)' : _k, _l = _a.playIconColor, playIconColor = _l === void 0 ? '#333' : _l, _m = _a.playIconPulsing, playIconPulsing = _m === void 0 ? true : _m, _o = _a.playIconSize, playIconSize = _o === void 0 ? 16 : _o, lazyConfig = _a.lazyConfig, disableLazyLoading = _a.disableLazyLoading, previewUrl = _a.previewUrl;
    var _p = react_2.useState(false), playing = _p[0], setPlaying = _p[1];
    var _q = react_2.useState(poster), thumbnail = _q[0], setThumbnail = _q[1];
    var _r = react_2.useState(true), showOverlay = _r[0], setShowOverlay = _r[1];
    var _s = react_2.useState(previewUrl !== null && previewUrl !== void 0 ? previewUrl : url), videoUrl = _s[0], setVideoUrl = _s[1];
    var isPreview = videoUrl === previewUrl;
    var player = react_2.useRef(null);
    var playerConfig = {
        autoplay: isPreview ? true : autoplay,
        muted: isPreview ? true : muted,
        color: color.replace('#', ''),
        title: title,
        dnt: true,
        preload: true
    };
    react_2.useEffect(function () {
        // Get thumbnail from vimeo if poster not set
        if (!poster && (url === null || url === void 0 ? void 0 : url.includes('vimeo'))) {
            axios_1.default.get('https://vimeo.com/api/oembed.json?url=' + url).then(function (res) {
                var _a;
                setThumbnail((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.thumbnail_url);
            });
        }
    }, []);
    var onStartHandler = function () {
        sendEvent('VIDEO_Started');
    };
    return (react_1.default.createElement(PlayerWrapper, { boxShadow: boxShadow },
        react_1.default.createElement(lazy_1.default, { className: "react-player", ref: player, url: videoUrl, controls: isPreview ? false : controls, loop: isPreview ? true : loop, muted: isPreview ? true : muted, volume: volume, playing: playing, playsinline: playsinline, width: '100%', height: '100%', onStart: isPreview ? undefined : onStartHandler, onEnded: isPreview ? undefined : function () { return sendEvent('VIDEO_Ended'); }, onProgress: isPreview ? undefined : onProgress, config: {
                youtube: {
                    playerVars: playerConfig
                },
                vimeo: {
                    playerOptions: playerConfig
                },
                file: {
                    attributes: {
                        autoPlay: isPreview,
                        muted: isPreview,
                        controls: isPreview ? false : controls
                    }
                }
            } }),
        showOverlay && (react_1.default.createElement(ConditionalLazyLoad, { disableLazyLoading: disableLazyLoading, lazyConfig: lazyConfig },
            react_1.default.createElement(OverlayContainer, { onClick: function () {
                    setShowOverlay(false);
                    setVideoUrl(url);
                    setPlaying(true);
                }, poster: previewUrl ? '' : thumbnail, playIconSize: playIconSize, playIconColor: playIconColor },
                react_1.default.createElement("div", { className: "player-icon-container" },
                    playIconPulsing && react_1.default.createElement("div", { className: "play-icon-pulsing" }),
                    react_1.default.createElement("div", { className: "play-icon" })))))));
};
exports.default = VideoPlayer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=VideoPlayer.js.map